import { LinkInfo } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 山積シミュレーション実行情報取得API
 */
export class SimulationInfoGateway {
  static getSimulationInfo = async (
  ) => {
    return await yamadumiApi.get<LinkInfo>(
      '/api/simulation/simulation-info'
    )
  }
}
